import { useState } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { ResourceVersionArtifactType } from '../../../types'
import { webApiEndpoints } from '../../../config'
import CarouselContainer from '../../../components/containers/CarouselContainer';
import ImageFile from '../../../components/artifacts/ImageFile';

interface AttachmentsTicketProps {
    title: string;
    idCredential: number;
    attachments: ResourceVersionArtifactType[]
}

export default function AttachmentsTicket({ title, idCredential, attachments }: Readonly<AttachmentsTicketProps>) {
    const [open, setOpen] = useState(false);
    const getUrl = (id: number, original = false) => {
        return `${process.env.REACT_APP_URL_PORTAL_API}${webApiEndpoints.tickets.adjuntoIssue.url}/${idCredential}/${id}/${original ? 'origen' : 'min'}`;
    }
    return (
        <div>
            <div className='form-contain-preview'>
                {attachments.map(a => <div
                    key={a.id}
                    className='form-contain-preview-item'
                    style={{ cursor: 'pointer' }}
                    onClick={() => setOpen(true)}
                >
                    <ImageFile src={getUrl(a.id)} alt={a.name} />
                    <Typography className='form-contain-preview-item-footer' variant='caption'>
                        <small>{a.name}</small>
                    </Typography>
                </div>)}
            </div>
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={({ position: 'absolute', right: 8, top: 8 })}
                >
                    X
                </IconButton>
                <DialogContent>
                    <CarouselContainer
                        timer={false}
                        items={attachments.map(a => ({
                            content: <ImageFile
                                src={getUrl(a.id, true)}
                                alt={a.name}
                                style={{ maxWidth: '100%', maxHeight: '75vh' }}
                                loading="lazy" />,
                            title: a.name
                        }))}
                    />
                </DialogContent>
            </Dialog>
        </div>
    )
}
